export enum NoticeState {
  Draft = "DRAFT",
  Published = "PUBLISHED",
}
